import React, { useState, useContext } from 'react'
import Image from '@boltui/image'
import { ThemeProvider, ThemeContext } from 'styled-components'

import { getSearchPath } from '@boltui/utils'
import SearchBar from '@boltui/search-bar'
import { MenuIcon, StoreIcon, InfoIcon, TrolleyIcon, AccountIcon, WishlistIcon } from '@boltui/icons'

import * as Styled from './Fallback.styles'

const logoUrl = 'https://media.4rgos.it/i/Argos/logo_argos2x'
const href = '/'

const TopBar = () => (
  <Styled.TopBar>
    <Styled.TopLink href='/stores/'>
      <StoreIcon />
      <span>Stores</span>
    </Styled.TopLink>
    <Styled.TopLink href='/help/'>
      <InfoIcon />
      <span>Help</span>
    </Styled.TopLink>
  </Styled.TopBar>
)

const Logo = () => (
  <Styled.LogoContainer>
    <Styled.LogoLink href={href}>
      <Image width={120} src={logoUrl} fallbackFmt='fmt=png' alt='Argos Logo - Load homepage' />
    </Styled.LogoLink>
  </Styled.LogoContainer>
)

// A no-frills fallback - has no logged in state, no meganav, no autosuggest, no
// trolley counts, no analytics, no SPA routing etc. Will rarely be seen by users.
const Fallback = () => {
  const [searchTerm, setSearchTerm] = useState('')
  const currentTheme = useContext(ThemeContext)

  // Header search bar is grey
  const greyscaleTheme = {
    ...currentTheme,
    color_grey_mid: currentTheme.color_grey_dark,
    color_secondary: currentTheme.color_grey_dark,
    color_secondary_dark: currentTheme.color_grey_darker
  }

  const onSearch = () => {
    if (searchTerm.trim()) {
      window.location.href = `${getSearchPath(searchTerm)}`
    }
  }

  return (
    <Styled.Header>
      <TopBar />
      <Styled.Main>
        <Logo />
        <Styled.ShopLink href='/static/AtoZ.htm'>Shop</Styled.ShopLink>
        <Styled.Search>
          <ThemeProvider theme={greyscaleTheme}>
            <SearchBar
              value={searchTerm}
              placeholder='Search products, brands or FAQs'
              onChange={(evt) => setSearchTerm(evt.target.value)}
              onSubmit={onSearch}
            />
          </ThemeProvider>
        </Styled.Search>
        <Styled.Icons>
          <Styled.IconLink href='/static/AtoZ.htm' className='md-hidden'>
            <MenuIcon />
            <span>Shop</span>
          </Styled.IconLink>
          <Styled.IconLink href='/account/login'>
            <AccountIcon />
            <span>Account</span>
          </Styled.IconLink>
          <Styled.IconLink href='/wishlist'>
            <WishlistIcon />
            <span>Wishlist</span>
          </Styled.IconLink>
          <Styled.IconLink href='/basket'>
            <TrolleyIcon />
            <span>Trolley</span>
          </Styled.IconLink>
        </Styled.Icons>
      </Styled.Main>
    </Styled.Header>
  )
}

export default Fallback
